<template>
  <!-- 在抽奖面板中展示的奖项 -->
  <Award :awardData="awardData" :tpl="tpl" />
</template>

<script>
import Award from './awardItem/Award';
export default {
  components: { Award },
  props: {
    awardData: {
      type: Object,
      required: true
    }
  },
  computed: {
    tpl() {
      if (this.awardData.rewardType === 'RED_PACKET') {
        // 如果是红包，展示为不确定金额红包样式
        return 'FUZZY_RED_PACKET';
      }
      return this.awardData.rewardType;
    }
  }
};
</script>
